import { ChatWidget as SupportChatWidget } from "@/components/CustomerSupport/ChatWidget";

export const ChatWidget = () => (
  <SupportChatWidget
    accountType="vendor"
    className="bottom-40"
    iconClassName="bottom-[6.25rem]"
  />
);
